"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyRegistry__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "proxies",
        outputs: [
            {
                internalType: "contract OwnableDelegateProxy",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5060d18061001f6000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063c455279114602d575b600080fd5b60536038366004606f565b6000602081905290815260409020546001600160a01b031681565b6040516001600160a01b03909116815260200160405180910390f35b600060208284031215607f578081fd5b81356001600160a01b03811681146094578182fd5b939250505056fea2646970667358221220516b42738773587dd9cefeaf7c304c30db65537a3a24f6ac687e15b7ea52f42264736f6c63430008020033";
class ProxyRegistry__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ProxyRegistry__factory = ProxyRegistry__factory;
ProxyRegistry__factory.bytecode = _bytecode;
ProxyRegistry__factory.abi = _abi;
//# sourceMappingURL=ProxyRegistry__factory.js.map